import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_CLRParser = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="CLR PARSER"
    videos={[
      "https://www.youtube.com/embed/iAYmAluXVq0",
      "https://www.youtube.com/embed/fpPzWswvkJw",
    ]}
    takeaways={[]}
    questions={[
      `Consider the following grammar. Construct the CLR parsing table and parse the input "a*b+a". Provide a step-by-step explanation of the parsing process.

E -> E + T | T
T -> T F | F
F -> F * | a | b`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_CLRParser;
